define('views/modules/calendar/animated-session/animation/rename/custom-names-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/animation/rename/custom-names-manager-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VCustomNamesManagerContent
) {

    var VCustomNamesManagerPanel = VBasePanel.extend({
        header: {
            title: "calendar:Custom exercise names",
            subtitle: "calendar:Adding/Modify a custom exercise name",
        },
        tabs: [{ id: 'manage', title: 'Manage', icon: 'sl-icon-settings', active: true }],

        content: {
            manage: VCustomNamesManagerContent,
        },
        defaultView: 'manage',
        initialize: function(opt) {
            opt = opt || {};
            var manage = this.getView('manage', {
                model: this.model,
                group: opt.group,
            });
        },
    });

    return VCustomNamesManagerPanel;
});

